const getAuthConfig = () => {
  const token = sessionStorage.getItem("authToken");
  return token
    ? {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    : { headers: {} };
};

export default getAuthConfig;
 